import LegalPageLayout from '@/components/LegalPageLayout';

export default function CookiePolicyPage() {
  return (
    <LegalPageLayout
      testId="cookie-policy-page"
      title="Cookie Policy"
      subtitle="A plain-language explanation of the cookies used on this website."
      lastUpdated="August 2026"
    >
      <h2>1. What Are Cookies?</h2>
      <p>
        Cookies are small text files placed on your device when you visit a website. They help websites
        function properly and, where used, help us understand how visitors use our site.
      </p>

      <h2>2. How We Currently Use Cookies</h2>
      <p>
        Peak 9 currently uses only <strong>essential/strictly necessary cookies</strong> required for
        core website functionality (e.g. remembering your cookie preference). We do not currently run
        analytics or advertising cookies.
      </p>
      <p>
        We plan to introduce analytics cookies (e.g. to understand which pages are most useful) in the
        near future. When we do, this policy will be updated and, where required by law, we will ask for
        your consent before activating them.
      </p>

      <h2>3. Types of Cookies We May Use</h2>
      <h3>Essential</h3>
      <p>Required for the website to work as intended. These cannot be switched off.</p>
      <h3>Analytics (planned, not yet active)</h3>
      <p>Would help us understand aggregate site usage, such as which pages are visited most often, so we can improve the experience.</p>
      <h3>Third-Party</h3>
      <p>
        Our embedded application forms (Tally.so) and Google Calendar booking links may set their own
        cookies when you interact with them. These are governed by the respective third party's own
        cookie/privacy policy.
      </p>

      <h2>4. Managing Your Cookie Preferences</h2>
      <p>
        You can accept or dismiss our cookie notice using the banner shown on your first visit. You can
        also control or delete cookies at any time through your browser settings — most browsers allow you
        to block or clear cookies via their privacy settings.
      </p>

      <h2>5. Changes to This Policy</h2>
      <p>We will update this page whenever the cookies we use change. Please check back periodically.</p>

      <h2>6. Contact Us</h2>
      <p>
        Questions about our use of cookies? Email us at <a href="mailto:contact@peak9.in">contact@peak9.in</a>.
      </p>
    </LegalPageLayout>
  );
}
